// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YF2Q","newExpiryDate":"styles_newExpiryDate__3f5op","footer":"styles_footer__1C5YT"};